import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import {
    agregarFC_01AnexoProductoresBeneficiario,
    editarFC_01AnexoProductorBeneficiario,
    eliminarFC_01AnexoProductorBD,
    agregarFC_01AnexoProductorBeneficiario
} from '../../redux/DucksBeneficiario/FC_01Ducks';
import {
    agregarFC_01ProductorMap
} from '../../redux/DucksAtencionACliente/FC_01AtencionAClienteDucks';
const { useState, useEffect, useRef } = React;
import { useStateIfMounted } from 'use-state-if-mounted'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faCannabis, faClover, faHandSpock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faBoxOpen, faDumpsterFire, faXmark)
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faCannabis, faClover, faHandSpock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faBoxOpen, faDumpsterFire, faXmark
} from '@fortawesome/free-solid-svg-icons'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

import estilos from './PredioYProductor.module.css'
import ModalComponent from './ModalComponent';

const PredioComponent = (props) => {
    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    const dispatch = useDispatch()

    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0].id
    const modoCorreccion = useSelector(store => store.FC_01Solicitud.modoCorreccion)
    const modoEdicionBorrador = useSelector(store => store.FC_01Solicitud.modoEdicionBorrador)
    let productor = props.productor
    const componente = props.componente
    const map = props.map
    const [observacionesProductor, setObservacionesProductor] = useStateIfMounted(props.observacionesProductor);
    const actualizarObservacionesProductor = (data) => {
        const nuevoObservacionProductor = observacionesProductor.filter(field => field.id === data.id)
        nuevoObservacionProductor[0][data.campo] = data.valor

        let campo = data.campo.replace('check', '')
        if (data.valor) {
            handleOpenModalObservaciones()
            mostrarModal({ id: data.id, campo: campo, anexo: 'productor' })
        } else {
            nuevoObservacionProductor[0][campo] = ''
        }
        setObservacionesProductor([...observacionesProductor]);
        // dispatch(agregarFC_01ProductorMap(observacionesProductor))
    }
    const [openModalObservaciones, setOpenModalObservaciones] = React.useState(false);
    const handleOpenModalObservaciones = () => setOpenModalObservaciones(true);
    const handleCloseModalObservaciones = () => setOpenModalObservaciones(false);

    const handleCloseModalObservacionesX = () => {
        setOpenModalObservaciones(false);

        desactivarCheck(campoParaObservacion);
    }
    const [observacionArea, setObservacionArea] = useStateIfMounted('')
    let [campoParaObservacion, setCampoParaObservacion] = useStateIfMounted('')
    const mostrarModal = (campo) => {
        setCampoParaObservacion(campo)
    }
    const modalComponentObservaciones = (campo) => {
        return (
            <Fragment>
                <Modal
                    open={openModalObservaciones}
                    onClose={handleCloseModalObservacionesX}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    disableEnforceFocus
                >
                    <Box sx={style}>
                        <div className={`${estilos.textRight}`}>
                            <button className='btn' onClick={handleCloseModalObservacionesX}>
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                        </div>

                        <div align="center">
                            <label align="center"> <b>OBSERVACIONES</b></label>
                        </div>

                        <textarea type="textarea" rows="3" className="form-control"
                            placeholder='Detalle de la observacion.'
                            value={observacionArea} onChange={e => setObservacionArea(e.target.value)} />

                        <br />
                        <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                            <button className='btn btn-dark' onClick={e => botonGuardarObservaciones(observacionArea)}>Aceptar</button>
                        </div>

                    </Box>
                </Modal>
            </Fragment>

        )
    }
    const botonGuardarObservaciones = async (observacion) => {

        switch (campoParaObservacion.anexo) {
            case 'productor':
                const nuevoObservacionProductor = observacionesProductor.filter(field => field.id === campoParaObservacion.id)
                nuevoObservacionProductor[0][campoParaObservacion.campo] = observacion
                setObservacionesProductor([...observacionesProductor])
                props.history.push('/fc_01',  {observacionesProductor:observacionesProductor} )
                break;
            default:
                break

        }
        handleCloseModalObservaciones()
        setObservacionArea('')
        setCampoParaObservacion('')
    }

    const handleAddProductos = () => {
        let anexo = {
            id: uuidv4(), cultivado: false, semicultivado: false, silvestre: false, nombreparaje: '',
            estado: '', distrito: '', municipio: '', localidad: ''
        }
        if (modoEdicionBorrador) {
            productor = ([...productor, anexo])
            switch (componente) {
                case 'fc_01':
                    dispatch(agregarFC_01AnexoProductorBeneficiario(anexo))
                    break;
                default:
                    break;
            }
        } else {
            productor = ([...productor, anexo])
            switch (componente) {
                case 'fc_01':
                    dispatch(agregarFC_01AnexoProductoresBeneficiario({ data: productor }))
                    break;
                default:
                    break;
            }
        }

    };

    const handleOnChangueProductor = (data) => {
        switch (componente) {
            case 'fc_01':
                dispatch(editarFC_01AnexoProductorBeneficiario(data))
                break;
            default:
                break;
        }
    }
    const deleteProductor = (inputField) => {
        props.handdleDeleteOptionFile(inputField.id)
        const fields = productor.filter(fields => fields.id !== inputField.id)
        productor = fields
        switch (componente) {
            case 'fc_01':
                if (inputField.idfc01_anexoproductor) {
                    dispatch(eliminarFC_01AnexoProductorBD(inputField.idfc01_anexoproductor))
                }
                dispatch(agregarFC_01AnexoProductoresBeneficiario({ data: fields }))
                break;
            default:
                break;
        }
    }

    return (
        <Fragment>
            <div className='container'>

                {
                    productor.map((inputField, index) => (
                        <div key={index} className='row'>
                            <div className='row align-items-center'>
                                <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                    <h6 className={'text-center'}><b>Tipo de plantación</b></h6>
                                    {inputField.cultivado === false && inputField.semicultivado === false && inputField.silvestre === false ?
                                            (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                    <input type="checkbox" id=""
                                        className={`form-check-input me-1 ${map.length > 0 ? 'inputValidado' : ''}`}
                                        onChange={e => handleOnChangueProductor(
                                            {
                                                valor: e.target.checked,
                                                id: inputField.id,
                                                campo: 'cultivado'
                                            })}
                                        value={inputField.cultivado}
                                        checked={inputField.cultivado}
                                    />
                                    <label className="form-check-label me-4  label-blanco" htmlFor="flexCheckChecked" >
                                        CULTIVADO
                                    </label>
                                </div>


                                <div className='col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                                    <input type="checkbox" id=""
                                        className={`form-check-input me-1 ${map.length > 0 ? 'inputValidado' : ''}`}
                                        onChange={e => handleOnChangueProductor(
                                            {
                                                valor: e.target.checked,
                                                id: inputField.id,
                                                campo: 'semicultivado'
                                            })}
                                        value={inputField.semicultivado}
                                        checked={inputField.semicultivado}
                                    />
                                    <label className="form-check-label me-4  label-blanco" htmlFor="flexCheckChecked" >
                                        SEMICULTIVADO
                                    </label>
                                </div>

                                <div className='col-xs-2 col-sm-2 col-md-3 col-lg-3 col-xl-3'>
                                    <input type="checkbox" id=""
                                        className={`form-check-input me-1 ${map.length > 0 ? 'inputValidado' : ''}`}
                                        onChange={e => handleOnChangueProductor(
                                            {
                                                valor: e.target.checked,
                                                id: inputField.id,
                                                campo: 'silvestre'
                                            })}
                                        value={inputField.silvestre}
                                        checked={inputField.silvestre}
                                    />
                                    <label className="form-check-label  label-blanco" htmlFor="flexCheckChecked" >
                                        SILVESTRE
                                    </label>
                                </div>
                                <br /><br />
                            </div>

                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>

                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${map.length > 0 ? 'inputValidado' : ''}`}
                                        id="floatingInput" placeholder='Paraje'
                                        onChange={e => handleOnChangueProductor(
                                            {
                                                valor: e.target.value,
                                                id: inputField.id,
                                                campo: 'nombreparaje'
                                            })}
                                        value={inputField.nombreparaje}
                                    />
                                    <label htmlFor='floatingInput' className='label-dark'>Nombre del paraje</label>
                                    {inputField.nombreparaje.length===0 ?(<span className='text-danger'>Campo obligatorio</span>):''}
                                </div>
                            </div>
                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${map?.filter(map => map?.idfc01_anexoproductor
                                        === inputField.idfc01_anexoproductor)[0]?.domiciliocheck !== undefined ? (map?.filter(map => map.idfc01_anexoproductor
                                            === inputField.idfc01_anexoproductor)[0]?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} 
                                        id="floatingInput" placeholder='Estado'
                                        onChange={e => handleOnChangueProductor(
                                            {
                                                valor: e.target.value,
                                                id: inputField.id,
                                                campo: 'estado'
                                            })}
                                        value={inputField.estado}
                                    />
                                    <label htmlFor='floatingInput' className='label-dark'>Estado</label>
                                    {inputField.estado.length===0 ?(<span className='text-danger'>Campo obligatorio</span>):''}
                                    <span className={`${map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck !== undefined ? (
                                    map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck ? 'text-danger'
                                    : 'text-success') : ('')}`}>{map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck?
                                    (map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domicilio):''}</span>
                                </div>
                            </div>
                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${map?.filter(map => map?.idfc01_anexoproductor
                                        === inputField.idfc01_anexoproductor)[0]?.domiciliocheck !== undefined ? (map?.filter(map => map.idfc01_anexoproductor
                                            === inputField.idfc01_anexoproductor)[0]?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                         id="floatingInput" placeholder='Distrito'
                                        onChange={e => handleOnChangueProductor(
                                            {
                                                valor: e.target.value,
                                                id: inputField.id,
                                                campo: 'distrito'
                                            })}
                                        value={inputField.distrito}
                                    />
                                    <label htmlFor='floatingInput' className='label-dark'>Distrito</label>
                                    <span className={`${map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck !== undefined ? (
                                    map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck ? 'text-danger'
                                    : 'text-success') : ('')}`}>{map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck?
                                        (map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domicilio):''}</span>
                                    <br />
                                </div>
                            </div>
                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${map?.filter(map => map?.idfc01_anexoproductor
                                        === inputField.idfc01_anexoproductor)[0]?.domiciliocheck !== undefined ? (map?.filter(map => map.idfc01_anexoproductor
                                            === inputField.idfc01_anexoproductor)[0]?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} 
                                        id="floatingInput" placeholder='Municipio'
                                        onChange={e => handleOnChangueProductor(
                                            {
                                                valor: e.target.value,
                                                id: inputField.id,
                                                campo: 'municipio'
                                            })}
                                        value={inputField.municipio}
                                    />
                                    <label htmlFor='floatingInput' className='label-dark'>Municipio</label>
                                    {inputField.municipio.length===0 ?(<span className='text-danger'>Campo obligatorio</span>):''}
                                    <span className={`${map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck !== undefined ? (
                                    map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck ? 'text-danger'
                                    : 'text-success') : ('')}`}>{map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck?
                                        (map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domicilio):''}</span>
                                </div>
                            </div>
                            <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${map?.filter(map => map?.idfc01_anexoproductor
                                        === inputField.idfc01_anexoproductor)[0]?.domiciliocheck !== undefined ? (map?.filter(map => map.idfc01_anexoproductor
                                            === inputField.idfc01_anexoproductor)[0]?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} 
                                        id="floatingInput" placeholder='Localidad'
                                        onChange={e => handleOnChangueProductor(
                                            {
                                                valor: e.target.value,
                                                id: inputField.id,
                                                campo: 'localidad'
                                            })}
                                        value={inputField.localidad}
                                    />
                                    <label htmlFor='floatingInput' className='label-dark'>Localidad</label>
                                    {inputField.localidad.length===0 ?(<span className='text-danger'>Campo obligatorio</span>):''}
                                    <span className={`${map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck !== undefined ? (
                                    map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck ? 'text-danger'
                                    : 'text-success') : ('')}`}>{map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domiciliocheck?
                                        (map?.filter(map => map.idfc01_anexoproductor === inputField.idfc01_anexoproductor)[0]?.domicilio):''}</span>
                                </div>
                            </div>
                            {tipoUsuario !== 3 ? (<Fragment>
                                {
                                    !modoCorreccion &&<Fragment>
                                        {/* <div className='mt-2 col-md-5 border-secondary'></div> */}
                                    <div className='mt-2 col-md-1 border-secondary'>
                                        <ModalComponent api={{ deleteAnexo: deleteProductor, inputField }} text="un predio" />
                                    </div>
                                    </Fragment>
                                }</Fragment>) : ''
                            }


                        </div>

                    ))
                }
                {modalComponentObservaciones(campoParaObservacion)}
                {tipoUsuario !== 3 ? (<Fragment>
                    {
                        !modoCorreccion &&
                        <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                            <button className='botonAgregarAnexo col-md-2'
                                onClick={e => handleAddProductos()}
                            >Agregar predio</button>
                            {productor.length===0?(<span className='text-danger'>Campo obligatorio</span>):''}
                        </div>
                    }</Fragment>) : ''
                }

            </div>

        </Fragment>
    )
};
export default withRouter(PredioComponent)